import React, { useRef, useLayoutEffect } from 'react';

import { TextInput } from 'components/Form';

import usePrevious from './usePrevious';

interface SingleVerificationInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  focus?: boolean;
  isNumberInput?: boolean;
}

const SingleVerificationInput = ({
  focus,
  autoFocus,
  isNumberInput,
  className,
  ...rest
}: SingleVerificationInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const prevFocus = usePrevious(!!focus);
  const numberInputProps: Partial<React.InputHTMLAttributes<HTMLInputElement>> = isNumberInput
    ? { inputMode: 'numeric', pattern: '[0-9]*', min: '0' }
    : {};

  useLayoutEffect(() => {
    const { current } = inputRef;

    if (!current) {
      return;
    }

    if (focus && autoFocus) {
      current.focus();
    }

    if (focus && autoFocus && focus !== prevFocus) {
      current.focus();
      current.select();
    }
  }, [autoFocus, focus, prevFocus]);

  return <TextInput {...rest} {...numberInputProps} inputRef={inputRef} inputClassName={className} />;
};

export default SingleVerificationInput;
